import type { ReactNode } from 'react';
import { Icon } from '@renderer/shared/components/icons';
import { EditorTabs, SelectField, ToolbarGroup } from '@renderer/shared/components/primitives';
import type { ResourcesCategoryFilter, ResourcesSort } from '../resources-view-store';

export function ResourcesToolbar({
  projectOptions,
  projectFilter,
  onProjectFilterChange,
  sort,
  sortOptions,
  onSortChange,
  categoryFilter,
  onCategoryFilterChange,
  categoryTabs,
  uploadAction,
  trailing
}: {
  projectOptions: Array<{ value: string; label: string }>;
  projectFilter: 'all' | string;
  onProjectFilterChange: (value: 'all' | string) => void;
  sort: ResourcesSort;
  sortOptions: Array<{ value: ResourcesSort; label: string }>;
  onSortChange: (value: ResourcesSort) => void;
  categoryFilter: ResourcesCategoryFilter;
  onCategoryFilterChange: (value: ResourcesCategoryFilter) => void;
  categoryTabs: Array<{ id: ResourcesCategoryFilter; label: string; icon: Parameters<typeof Icon>[0]['name'] }>;
  uploadAction?: ReactNode;
  trailing?: ReactNode;
}): JSX.Element {
  return (
    <div className="av-resources-toolbar">
      <ToolbarGroup className="av-resources-toolbar__left">
        <div className="av-select-with-icon">
          <Icon name="filter" />
          <SelectField value={projectFilter} options={projectOptions} onChange={(event) => onProjectFilterChange(event.target.value)} />
        </div>
        <SelectField
          value={sort}
          options={sortOptions.map((option) => ({ value: option.value, label: option.label }))}
          onChange={(event) => onSortChange(event.target.value as ResourcesSort)}
        />
      </ToolbarGroup>

      <div className="av-resources-toolbar__center">
        <EditorTabs tabs={categoryTabs} value={categoryFilter} onChange={onCategoryFilterChange} />
      </div>

      <ToolbarGroup className="av-resources-toolbar__right">
        {uploadAction}
        {trailing}
      </ToolbarGroup>
    </div>
  );
}
